import React, { Component } from 'react'
import { getScrappedData } from './services/PostApi';
import uuid from 'react-uuid';
import * as _ from "lodash";
import CleverTapUtils from './commons/CleverTapUtils';

class CommonOurSolutionGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageUrl: "",
            videoLink: this.props.videoLink
        }
    }

    getImageData = async (videoLink) => {
        let postData = {
            url: videoLink
        }
        let response = await getScrappedData(postData);
        if (response?.status === 200 && !_.isEmpty(response?.data)) {
            this.setState({
                imageUrl: response?.data?.image
            })
        } else {
            this.setState({
                imageUrl: response
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.videoLink && (this.state.videoLink !== nextProps.videoLink)) {
            this.getImageData(nextProps?.videoLink); 
        }
    }

    componentDidMount() {
        this.getImageData(this.props.videoLink);
    }

    render() {
        const { imageUrl, videoLink } = this.state;
        return (
            <>
                {imageUrl && 
                    <div className="vidBox">
                        <a href={videoLink} data-fancybox={uuid()} onClick={() => {CleverTapUtils.eventClick({}, "Play Video") ;}}>
                            <img src={imageUrl} alt="" />
                            <span className="btnYoutube"></span>
                        </a>
                    </div>
                }
            </>
            
        )
    }
}

export default CommonOurSolutionGrid;
